module.exports = __webpack_public_path__ + "img/windy_a.883ef368.jpeg";